// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/img/background2.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: fixed;
    background-position: center;
    background-color: #f0f0f0;
    background-position: 30%;

}

.candidatos-container {
    width: 100%;
    height: 100vh;
}

.candidatos-content {
}`, "",{"version":3,"sources":["webpack://./src/styles/Candidatos.css"],"names":[],"mappings":"AAAA;IACI,yDAAoD;IACpD,4BAA4B;IAC5B,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;IAC3B,yBAAyB;IACzB,wBAAwB;;AAE5B;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;AACA","sourcesContent":["body {\n    background-image: url('/public/img/background2.jpg');\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-attachment: fixed;\n    background-position: center;\n    background-color: #f0f0f0;\n    background-position: 30%;\n\n}\n\n.candidatos-container {\n    width: 100%;\n    height: 100vh;\n}\n\n.candidatos-content {\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
